fragment SaveReactionResponseFragment on SaveReactionResponse {
  ari
  containerAri
  emojiId
  __typename
}

fragment ReactionsSummaryResponseFragment on ReactionsSummaryResponse {
  ari
  containerAri
  reactionsSummaryForEmoji {
    emojiId
    count
    reacted
    __typename
  }
  __typename
}

fragment ReactedUsersResponseFragment on ReactedUsersResponse {
  ari
  containerAri
  count
  emojiId
  reacted
  confluencePerson {
    accountId
    displayName
    type
    __typename
  }
  __typename
}
